var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h3", [_vm._v("Sign-Up Links")]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "alert alert-info" }, [
            _c("p", [_vm._v("Loading current sign-up link for domain")])
          ])
        : _vm.currentLinks.length > 0
        ? _c(
            "div",
            [
              _c("h4", [
                _vm._v(
                  "Current Link" +
                    _vm._s(_vm.currentLinks.length > 1 ? "s" : "")
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.currentLinks, function(currentLink) {
                return _c("SignupLinkCurrent", {
                  key: currentLink["signup_token"],
                  attrs: {
                    "current-link": currentLink,
                    "link-status": _vm.linkStatus(currentLink),
                    "domain-uuid": _vm.domainUuid,
                    loading: _vm.loading,
                    "timezone-abbrev": _vm.timezoneAbbrev,
                    "timezone-message": _vm.timezoneMessage
                  },
                  on: { updatedLink: _vm.updateCurrentLinks }
                })
              })
            ],
            2
          )
        : _c("div", { staticClass: "alert alert-info" }, [
            _c("p", [_vm._v("No active sign-up link exists for this domain.")])
          ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      !_vm.loading
        ? _c("SignupLinkNew", {
            attrs: {
              "uses-external-id": _vm.usesExternalId,
              "domain-uuid": _vm.domainUuid,
              "timezone-message": _vm.timezoneMessage,
              "toolkit-max-users": _vm.toolkitMaxUsers
            },
            on: { updatedLink: _vm.handleUpdatedLink }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentLinks.length > 0
        ? _c("div", { staticClass: "alert alert-info" }, [
            _vm._v(
              "\n    Caution: Generating a new link will expire the current link.\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("SignupLinksPast", {
        attrs: {
          "past-links": _vm.pastLinks,
          "timezone-abbrev": _vm.timezoneAbbrev,
          "timezone-message": _vm.timezoneMessage
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }